module.exports = __webpack_public_path__ + "static/media/strongher9.47231c9f.jpg";